import { render } from "./PhoneCallIcon.vue?vue&type=template&id=050b49d4"
import script from "./PhoneCallIcon.vue?vue&type=script&lang=ts"
export * from "./PhoneCallIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script